export const CONTACT_US_DATA = {
  phone: "+91 8123727036",
  supportEmail: "support@ridengo.in",
  address: "DN-58-13-74/51, FLAT-401,Vasavi Paradise,Gowri NGR,Visakhapatnam (Urban),N A D,Visakhapatnam-530009,Andhra Pradesh.",
  gstin: "29AABCU0001R1Z5",
  companyName: "ENIF Tech Private Limited",
};